import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13175d47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "description" }
const _hoisted_2 = { class: "description__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description__content__header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "description__content__header__title" }, "Team Story")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description__content__body" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"black"} }, [
      /*#__PURE__*/_createElementVNode("strong", null, "​")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"black"} }, [
      /*#__PURE__*/_createElementVNode("strong", null, "​")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"black"} }, [
      /*#__PURE__*/_createElementVNode("strong", null, "​")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"black"} }, [
      /*#__PURE__*/_createElementVNode("strong", null, "​")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"black"} }, [
      /*#__PURE__*/_createElementVNode("strong", null, "​")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, [
      /*#__PURE__*/_createElementVNode("strong", null, "Your project and team effort is the heart of our customers and our business")
    ]),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "U3t makes it is easy for anyone to create or participate in a team story."),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "Please feel free to add stories, assign a topic, heading, short descriptions, pictures and tags."),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, [
      /*#__PURE__*/_createElementVNode("b", null, [
        /*#__PURE__*/_createElementVNode("b", { style: {"background-color":"rgb(255, 255, 255)"} }, "Extended use of U3t Team stories?")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, [
      /*#__PURE__*/_createElementVNode("b", null, "Example:"),
      /*#__PURE__*/_createTextVNode(" ")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "Anyone can participate in our story on how ABB products, solutions and services contribute to customers Energy Transition & Sustainability. "),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "It is easy and we are not looking for exact science. :-)"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, [
      /*#__PURE__*/_createElementVNode("b", null, "Step 1")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, ":  in U3t select a Team. Selecting a team expose the related functions in U3t.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, [
      /*#__PURE__*/_createElementVNode("b", null, "Step 2")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, ": From the context menu select the 'Team story' function (It is the 'Heart beat' icon)")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, [
      /*#__PURE__*/_createElementVNode("b", null, "Step 3")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, ": Add one or more Team Story 'Information' item(s) add the "),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, [
      /*#__PURE__*/_createElementVNode("b", null, "Tag")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, " \""),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, [
      /*#__PURE__*/_createElementVNode("b", null, "Sustainability")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "\" "),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "and the body text with the format:"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, [
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(Tip copy the format required from this text :-)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"14px","margin-bottom":"14px"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "#ABB project's scope is: "),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, " [Supporting Contributor] [Direct Contributor]"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, " #Summary description: "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, " <Write a short description>"),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "#End User Project's total reduction is: "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, " [Estimated][Verified] "),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, " #Climate gas reduction CO2 Equivalents Tones / Year: "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "<nnn>"),
      /*#__PURE__*/_createElementVNode("br")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "#Description and source of data: "),
      /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "& lt;Write a short summary on background for figure and source if relevant & gt; "),
      /*#__PURE__*/_createElementVNode("br")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"14px","margin-bottom":"14px"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, "The Heading of the Team story entry can be any text you choose. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"verdana","font-size":"11pt"} }, " This is an example of a Team story information item for Northern Lights:& nbsp; "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("img", { style: {"max-width":"100%"} }),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"11pt","font-family":"verdana"} }, [
      /*#__PURE__*/_createElementVNode("b", null, "The Team story entries you create are automatically machine processed and visible in U3t")
    ]),
    /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"11pt","font-family":"verdana"} }, " Sales & Delivery References after each Tuesday update. "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/sites/NO-CompetenceLibrary/PowerBI/SitePages/SalesReferences.aspx",
      title: "Link to Sales References"
    }, [
      /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"11pt","font-family":"verdana"} }, "Link to Sales & Delivery References")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong")
  ]),
  /*#__PURE__*/_createElementVNode("p", { style: {"background-color":"rgb(255, 255, 255)"} }, [
    /*#__PURE__*/_createTextVNode(" Note: We will enhance the solution based on your feedback and development plans​."),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Good practices:")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong"),
    /*#__PURE__*/_createElementVNode("span", { style: {"background-color":"rgb(255, 255, 255)","display":"inline !important"} }, "Write short and to the point. Add a picture. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"background-color":"rgb(255, 255, 255)","display":"inline !important"} }, "Add tags. (It might be useful to find and collect stories in your future of U3t.)")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Do not add pictures where persons can be identified unless it has been agreed with each person."),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))

import { isDevelopment } from "@/common/env";
import { getDescriptionItemFormUrl } from "@/common/urls";
import { fetchPageDescription } from "@/services/pageDescription";
import { useUserStore } from "@/stores/user";
import { PageDescription } from "@/types/PageDescriptionListItem";
import { storeToRefs } from "pinia";
import { ref, computed, onMounted } from "vue";

const pageName = "TeamStory";
const title = "Team Story";

// const userStore = useUserStore();
// const { isManager } = storeToRefs(userStore);

// const description = ref<PageDescription | null>(null);

// const getPageDescription = () => {
//     if (isDevelopment) {
//         description.value = { Id: 56, Content: "Unable to load description" } as PageDescription;
//     }
//     else {
//         fetchPageDescription(pageName).then((d) => (description.value = d));
//     }
// };

// const editFromLink = computed(() => {
//     return getDescriptionItemFormUrl(description.value?.Id);
// });

// onMounted(() => {
//     getPageDescription();
// });


export default /*#__PURE__*/_defineComponent({
  __name: 'Description',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

function close() {
    emit("close");
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'xmark'],
          class: "description__content__header__close",
          onClick: close
        }),
        _hoisted_3,
        _hoisted_4
      ])
    ])
  ]))
}
}

})